export var BANNER_WRAPPER = 'BannerWrapper';
export var BANNER_IMAGE = 'BannerImage';
export var BANNER_ARROW = 'BannerArrow';
export var BANNER_CONTENT_WRAPPER = 'BannerContentWrapper';
export var BANNER_CATALOGUE_DATE_RANGE = 'BannerCatalogueDateRange';
export var BANNER_CATALOGUE_TITLE = 'BannerCatalogueTitle';
export var BANNER_QUIZ_TITLE = 'BannerQuizTitle';
export var BANNER_QUIZ_TEXT = 'BannerQuizText';
export var BANNER_CUSTOM_CONTENT = 'BannerCustomContent';
//# sourceMappingURL=banner.js.map